// CTCI department list - 14 departments (customized for CTCI)
// NOTE: This file is CTCI-specific and should NOT be synced from tasv1
export const departmentList = [
  {
    name: '方法設計部 Process Engineering Dept.',
    code: 'DU00'
  },
  {
    name: '土建設計部 Civil & Building Engineering Dept.',
    code: 'D400'
  },
  {
    name: '設備設計部 Mechanical & Equipment Engineering Dept.',
    code: 'D500'
  },
  {
    name: '儀控設計部 Instrumentation & Control System Engineering Dept.',
    code: 'D600'
  },
  {
    name: '管線設計部 Piping Engineering Dept.',
    code: 'D700'
  },
  {
    name: '電機設計部 Electrical Engineering Dept.',
    code: 'D800'
  },
  {
    name: '專案設計經理部 Project Engineering Managers Dept.',
    code: 'D200'
  },
  {
    name: '採購部 Procurement Dept.',
    code: 'DC00'
  },
  {
    name: '建造部 Construction Dept.',
    code: 'DM00'
  },
  {
    name: '安衛環管理部 HSE Management Dept.',
    code: 'AA00'
  },
  {
    name: '煉油石化工程事業部 HBO.',
    code: 'H000'
  },
  {
    name: '基礎及環能工程事業部 IEPBO.',
    code: 'M000'
  },
  {
    name: '高科技設施工程事業部 ATFBO.',
    code: 'F000'
  },
  {
    name: '智慧創新部 Intelligent Innovation Dept.',
    code: 'B200'
  },
];

export default departmentList;
